import { useQueryRequest } from 'components/table/contexts/query-request';
import {
  useQueryResponseCount,
  useQueryResponseLoading,
  useQueryResponsePagination
} from 'components/table/contexts/query-response';
import { ItemWithId, QueryResponseContextProps } from 'components/table/types';
import ReactPaginate from 'react-paginate';

type Props<T extends ItemWithId> = {
  queryResponseContext: React.Context<QueryResponseContextProps<T>>;
};

const ListPagination = <T extends ItemWithId>(props: Props<T>) => {
  const pagination = useQueryResponsePagination(props.queryResponseContext);
  const totalCount = useQueryResponseCount(props.queryResponseContext);
  const isLoading = useQueryResponseLoading(props.queryResponseContext);

  const { state, updateState } = useQueryRequest();

  const pageCount = Math.ceil(totalCount / state.items_per_page);

  const handlePageClick = (event: { selected: number }) => {
    const page = event.selected + 1;

    if (!page || isLoading || pagination.page === page) {
      return;
    }

    updateState({ page, items_per_page: pagination.items_per_page || 10 });
  };

  const forcePage = pageCount === 0 ? -1 : (state?.page ?? 0) - 1;

  return (
    <div className="d-flex justify-content-center">
      <div className="mb-2">
        <ReactPaginate
          nextLabel=" > "
          onPageChange={handlePageClick}
          pageRangeDisplayed={4}
          marginPagesDisplayed={2}
          pageCount={pageCount}
          forcePage={forcePage > pageCount ? pageCount : forcePage}
          previousLabel=" < "
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination"
          activeClassName="active"
          renderOnZeroPageCount={undefined}
        />
      </div>
    </div>
  );
};

export { ListPagination };
